// ============================================
// Login Page - Direct Login (No OTP)
// ============================================

import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Shield, Loader2, LogIn } from 'lucide-react';
import { useAuthStore, useToast } from '../stores';
import { useTranslation } from '../i18n/useTranslation';

export function Login() {
  const toast = useToast();
  const { t } = useTranslation();
  const { isAuthenticated, isLoading, directLogin } = useAuthStore();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    // Auto-login on page load
    handleDirectLogin();
  }, []);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleDirectLogin = async () => {
    if (isLoggingIn) return;
    setIsLoggingIn(true);
    
    const result = await directLogin();
    
    if (result.ok) {
      toast.success('تم تسجيل الدخول بنجاح');
    } else {
      setIsLoggingIn(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800 p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">{t('app.title')}</h1>
          <p className="text-slate-400 mt-2">{t('app.subtitle')}</p>
        </div>

        {/* Login Card */}
        <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700/50 p-6 shadow-xl">
          <div className="text-center space-y-6">
            {isLoading || isLoggingIn ? (
              <div className="py-8">
                <Loader2 className="w-12 h-12 animate-spin text-primary-400 mx-auto" />
                <p className="text-slate-300 mt-4">جاري تسجيل الدخول...</p>
              </div>
            ) : (
              <>
                <div className="py-4">
                  <LogIn className="w-12 h-12 text-primary-400 mx-auto mb-4" />
                  <p className="text-slate-300">اضغط للدخول إلى لوحة التحكم</p>
                </div>
                
                <button
                  onClick={handleDirectLogin}
                  disabled={isLoading}
                  className="btn-primary w-full justify-center text-lg py-3"
                >
                  <LogIn className="w-5 h-5" />
                  دخول
                </button>
              </>
            )}
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-slate-500 text-sm mt-6">
          CRM Sales-OS © 2026
        </p>
      </div>
    </div>
  );
}
